import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./BrowseBlock').then(m => ({default: m.BrowseBlock})),
)

export const browseBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
  ssrEnabled: false,
})
